import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    Checkbox, InputLabel, FormControl, Input, InputAdornment, IconButton,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import PageTitle from "../components/PageTitle";
import {
    useCreateUserFlagMutation,
    useGetUsersFlagsMutation,
    useListPersonQuery,
    useSaveUserFlagMutation
} from "../store/user/userApi";
import SearchIcon from "@mui/icons-material/Search";
import {SearchSharp} from "@mui/icons-material";
import copyObject from "../utils/copyObject";
import AddIcon from "@mui/icons-material/Add";
import MenuItem from "@mui/material/MenuItem";
import {useListAllChairsQuery} from "../store/chair/chairApi";
import {useGetFacultiesQuery} from "../store/faculty/facultyApi";

export default function UserFlagsPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [getFlags] = useGetUsersFlagsMutation();
    const [data, setData] = useState([]);
    const [hasAccess, setHasAccess] = useState(false);
    const [pattern, setPattern] = useState('');
    const [saveFlag] = useSaveUserFlagMutation(); 
    const [createFlagMode, setCreateFlagMode] = useState(false);
    // const {data: personData} = useGetPersonQuery();
    // useListPersonQuery
    const {data: personData} = useListPersonQuery();
    const [copyOfPersonData, setCopyOfPersonData] = useState([]);
    const [selectedPersonId, setSelectedPersonId] = useState(0);
    
    const {data: chairsData} = useListAllChairsQuery();
    const [copyOfChairsData, setCopyOfChairsData] = useState([]);
    const [selectedChairId, setSelectedChairId] = useState(0);

    const {data: facultiesData} = useGetFacultiesQuery();
    const [copyOfFacultiesData, setCopyOfFacultiesData] = useState([]);
    const [selectedFacultyId, setSelectedFacultyId] = useState(0);
    
    const [createFlagRequest] = useCreateUserFlagMutation();
    
    useEffect(() => {
        if (localStorage.getItem('roles').split(',').find((item) => item.toLowerCase() === 'attnewadmin') !== undefined) {
            setHasAccess(true);
        }
        
        if (chairsData) {
            setCopyOfChairsData(copyObject(chairsData).chairs.sort((l,r) => l.value > r.value ? 1 : -1));
        }
        
        if (facultiesData) {
            setCopyOfFacultiesData(copyObject(facultiesData).data.sort((l,r) => l.value > r.value ? 1 : -1));
        }
        
        if (personData) {
            setCopyOfPersonData(copyObject(personData).data.sort((l,r) => l.value > r.value ? 1 : -1));
        }
    }, [chairsData, facultiesData, personData]);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }
    
    async function loadData() {
        await getFlags({data: {
                pattern
            }}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setData(copyObject(fulfilled.data));
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });

                setIsSaving(false);
            }
        });
    }
    
    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    const handleSave = async (item) => {
        setIsSaving(true);

        await saveFlag({data: item}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Сохранено')
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        });
    };
    
    async function createFlag() {
        setCreateFlagMode(false);
        setIsSaving(true);

        await createFlagRequest({data: {
                personId: selectedPersonId,
                chairId: selectedChairId,
                facultyId: selectedFacultyId
            }}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Флаг успешно создан')
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch(() => {
            setIsSaving(false);
            alert('Ошибка');
        });
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Управление флагами пользователей`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       visibility={hasAccess}
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {data === null || data === undefined ? <CircularProgress /> : <></>}
                            Управление флагами пользователей 
                        </Typography>
                        <IconButton color={'primary'}
                                    onClick={() => setCreateFlagMode(true)}><AddIcon /></IconButton>
                    </Stack>

                    {createFlagMode
                        ?
                        <Card>
                            <CardContent>
                                <Stack spacing={2}>
                                    <Typography variant={'h6'}>Создание нового флага</Typography>

                                    <TextField label={'Преподаватель'}
                                               select
                                               size={'small'}
                                               value={selectedPersonId}
                                               onChange={(event) => setSelectedPersonId(event.target.value)}
                                               fullWidth>
                                        <MenuItem value={0}>Не выбрано</MenuItem>
                                        {copyOfPersonData.map((item) => {
                                            return <MenuItem key={`${item.value}_${item.key}`} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </TextField>
                                    
                                    <Typography>или</Typography>
                                    
                                    <TextField label={'Кафедра'}
                                               select
                                               size={'small'}
                                               value={selectedChairId}
                                               onChange={(event) => setSelectedChairId(event.target.value)}
                                               fullWidth>
                                        <MenuItem value={0}>Не выбрано</MenuItem>
                                        {copyOfChairsData.map((item) => {
                                            return <MenuItem key={`${item.value}_${item.key}`} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </TextField>

                                    <Typography>или</Typography>

                                    <TextField label={'Факультет'}
                                               select
                                               size={'small'}
                                               value={selectedFacultyId}
                                               onChange={(event) => setSelectedFacultyId(event.target.value)}
                                               fullWidth>
                                        <MenuItem value={0}>Не выбрано</MenuItem>
                                        {copyOfFacultiesData.map((item) => {
                                            return <MenuItem key={`${item.value}_${item.key}`} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </TextField>
                                </Stack>
                            </CardContent>
                            <Button variant={'contained'} 
                                    fullWidth
                                    disabled={isSaving}
                                    onClick={() => {createFlag()}}>Создать</Button>
                        </Card>
                    : <></>}
                    
                    <Card>
                        <CardContent>
                            <Stack direction={'row'} spacing={2}>
                                <FormControl variant="standard" fullWidth>
                                    <InputLabel htmlFor="input-with-icon-adornment">
                                        Поиск
                                    </InputLabel>
                                    <Input fullWidth
                                           onChange={(event) => {setPattern(event.target.value)}}
                                           id="input-with-icon-adornment"
                                           startAdornment={
                                               <InputAdornment position="start">
                                                   <SearchSharp />
                                               </InputAdornment>
                                           }
                                    />
                                </FormControl>

                                <Button variant={'outlined'} 
                                        disabled={pattern.length === 0}
                                        onClick={() => {loadData()}}>Найти</Button>
                            </Stack>
                        </CardContent>
                    </Card>

                    <Card>
                        <Stack spacing={2}>
                            <TableContainer>
                                <Table size={'small'}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Пользователь</TableCell>
                                            <TableCell align={'center'}>Включить виртуальные группы</TableCell>
                                            <TableCell align={'center'}>Может создавать сессии без ограничений</TableCell>
                                            <TableCell align={'center'}>Запрет на редактирование ведомостей</TableCell>
                                            <TableCell align={'center'}>За какой период в прошлом (в днях) можно редактировать журнал</TableCell>
                                            <TableCell align={'center'}>Снять ограничения на редактирование журнала до даты</TableCell>
                                            <TableCell align={'center'}>Включить БРС</TableCell>
                                            <TableCell align={'center'}>Включить ИИ-помощника</TableCell>
                                            <TableCell align={'center'}>Действия</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* <TableRow> */}
                                        {/*    <TableCell><strong><em>Установить всем</em></strong></TableCell> */}
                                        {/*    <TableCell align={'center'}><Checkbox /></TableCell> */}
                                        {/*    <TableCell align={'center'}><Checkbox /></TableCell> */}
                                        {/*    <TableCell align={'center'}><Checkbox /></TableCell> */}
                                        {/*    <TableCell align={'center'}><TextField type={'number'} size={'small'}/></TableCell> */}
                                        {/*    <TableCell align={'center'}><TextField type={'date'}  size={'small'}/></TableCell> */}
                                        {/*    <TableCell align={'center'}><Button variant={'contained'} size={'small'}>Сохранить</Button></TableCell> */}
                                        {/* </TableRow> */}
                                        {data?.sort((l,r) => l.title > r.title ? 1 : -1).map((item) => {
                                            return <TableRow>
                                                <TableCell><strong>{item.title}</strong></TableCell>
                                                <TableCell align={'center'}><Checkbox checked={item.virtualGroupEnabled} onChange={(event, checked) => {item.virtualGroupEnabled = checked; applyVisualChanges()}} /></TableCell>
                                                <TableCell align={'center'}><Checkbox checked={item.canCreateSessionsWithoutRestrictions} onChange={(event, checked) => {item.canCreateSessionsWithoutRestrictions = checked; applyVisualChanges()}} /></TableCell>
                                                <TableCell align={'center'}><Checkbox checked={item.prohibitSessionStatementsEditing} onChange={(event, checked) => {item.prohibitSessionStatementsEditing = checked; applyVisualChanges()}} /></TableCell>
                                                <TableCell align={'center'}><TextField type={'number'} size={'small'} value={item.lessonEditingRestrictionInDays} onChange={(event) => {item.lessonEditingRestrictionInDays = parseInt(event.target.value, 10); applyVisualChanges()}}/></TableCell>
                                                <TableCell align={'center'}><TextField type={'date'}  size={'small'}  value={formatDate(new Date(item.noLessonEditingRestrictionTillDate))} onChange={(event) => {item.noLessonEditingRestrictionTillDate = event.target.value; applyVisualChanges()}}/></TableCell>
                                                <TableCell align={'center'}><Checkbox checked={item.grcEnabled} onChange={(event, checked) => {item.grcEnabled = checked; applyVisualChanges()}} /></TableCell>
                                                <TableCell align={'center'}><Checkbox checked={item.aiAssistantEnabled} onChange={(event, checked) => {item.aiAssistantEnabled = checked; applyVisualChanges()}} /></TableCell>
                                                <TableCell align={'center'}>
                                                    <Button variant={'contained'}
                                                            size={'small'} 
                                                            onClick={() => handleSave(item)}
                                                            disabled={isSaving}>Сохранить</Button>
                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                    </Card>
                    
                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
